import PropTypes from "prop-types";
import React from "react";
import { Alert, FormFeedback, Input, Label, Form } from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// action
import { userForgetPassword } from "../../store/actions";

// import images
import logo from "../../assets/images/realtyspace-logo.png";

const ForgetPasswordPage = props => {

  //meta title
  document.title = "Forget Password | Skote - React Admin & Dashboard Template";

  const dispatch = useDispatch();

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: '',
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
    }),
    onSubmit: (values) => {
      dispatch(userForgetPassword(values, props.history));
    }
  });


  const ForgotPasswordProperties = createSelector(
    (state) => state.ForgetPassword,
    (forgetPassword) => ({
      forgetError: forgetPassword.forgetError,
      forgetSuccessMsg: forgetPassword.forgetSuccessMsg,
    })
  );

  const {
    forgetError,
    forgetSuccessMsg
  } = useSelector(ForgotPasswordProperties);

  return (
    <React.Fragment>
      <div className="auth-modern-wrapper">
        <div className="auth-modern-card">
          <div className="text-center mb-3">
            <img src={logo} alt="RealtySpace" height="32" />
          </div>
          <h4 className="auth-modern-title">Reset password</h4>
          <p className="auth-modern-subtitle">Enter your email and we'll send you a reset link</p>

          {forgetError ? (
            <Alert color="danger">{forgetError}</Alert>
          ) : null}
          {forgetSuccessMsg ? (
            <Alert color="success">{forgetSuccessMsg}</Alert>
          ) : null}

          <Form
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
          >
            <div className="mb-3">
              <Label className="form-label">Email</Label>
              <Input
                name="email"
                className="form-control"
                placeholder="Enter email"
                type="email"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.email || ""}
                invalid={
                  validation.touched.email && validation.errors.email ? true : false
                }
              />
              {validation.touched.email && validation.errors.email ? (
                <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
              ) : null}
            </div>

            <div className="mt-4 d-grid">
              <button
                className="btn btn-primary"
                type="submit"
              >
                Send Reset Link
              </button>
            </div>
          </Form>

          <div className="auth-modern-footer">
            Go back to{" "}
            <Link to="/login" className="text-primary fw-medium">
              Login
            </Link>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
};

export default withRouter(ForgetPasswordPage);
